"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _react = _interopRequireDefault(require("react"));
const Text = props => /*#__PURE__*/_react.default.createElement("svg", (0, _extends2.default)({
  width: 12,
  height: 13,
  viewBox: "0 0 12 13",
  fill: "none"
}, props), /*#__PURE__*/_react.default.createElement("path", {
  className: "fill",
  d: "M6.858 10.057l-2.813-7.5a.516.516 0 00-.965 0l-2.813 7.5a.516.516 0 00.966.362l.847-2.26a.047.047 0 01.044-.03h2.877a.047.047 0 01.044.03l.847 2.26a.516.516 0 00.966-.362zM2.502 7.034l1.017-2.71a.047.047 0 01.087 0l1.017 2.71a.047.047 0 01-.044.064H2.546a.047.047 0 01-.044-.064zm6.891-2.561a2.385 2.385 0 00-2.226 1.439.516.516 0 10.949.403c.208-.49.697-.807 1.25-.811a1.372 1.372 0 011.368 1.38.035.035 0 01-.034.034c-.513.015-1.123.049-1.666.113-1.284.15-2.05.85-2.05 1.871 0 .544.206 1.032.579 1.376.35.322.828.5 1.343.5.727 0 1.352-.188 1.827-.545h.001a.516.516 0 001.032.005V6.886c0-1.317-1.055-2.404-2.373-2.413zm-.487 5.273c-.41 0-.89-.221-.89-.844 0-.25.09-.425.291-.568.196-.139.497-.238.847-.279a18.3 18.3 0 011.527-.105.047.047 0 01.044.03.046.046 0 01.003.02c-.064 1.174-.662 1.746-1.822 1.746z",
  fill: "#ACB3BE"
}));
var _default = exports.default = Text;